import Card from "../../../../../../componentLibrary/Card";
import GripHandle from "../../../../../../componentLibrary/GripHandle";
import Input from "../../../../../../componentLibrary/Input";
import Textarea from "../../../../../../componentLibrary/Textarea";
import type { InputQuestionI, ToolboxQuestionI } from "../../../../../../types";

export default function InputQuestionCard({
  question,
  onChange,
  onRemove,
  index,
}: {
  question: InputQuestionI;
  onChange: (q: ToolboxQuestionI) => void;
  onRemove?: () => void;
  index?: number;
}) {
  const update = (field: string, value: string) =>
    onChange({
      ...question,
      content: { ...question.content, [field]: value },
    } as ToolboxQuestionI);

  return (
    <Card
      title={
        <span className="flex items-center gap-2">
          <GripHandle className="fill-gray-300 shrink-0" />
          {index !== undefined ? `Q${index + 1} · Input` : "Input"}
        </span>
      }
      onClose={onRemove}
    >
      <div className="space-y-2 mt-1">
        <Input
          label="Variable name"
          placeholder="e.g. sleep_hours_needed"
          value={question.variableName}
          onChange={(e) =>
            onChange({
              ...question,
              variableName: e.target.value,
            } as ToolboxQuestionI)
          }
        />
        <Input
          label="Label"
          placeholder="e.g. How are you feeling today?"
          value={question.content?.label ?? ""}
          onChange={(e) => update("label", e.target.value)}
        />
        <Textarea
          label="Placeholder"
          placeholder="e.g. Type your answer here…"
          value={question.content?.placeholder ?? ""}
          onChange={(e) => update("placeholder", e.target.value)}
        />
      </div>
    </Card>
  );
}
